import React, {useEffect, useState, Fragment} from 'react';

export default (props) => {
	
	return (
		<div className="card-block" >
			{props.objExists(props.location, 'carrier_name') &&
			<div>{props.site.translation && props.site.translation.projects.labels.shipped_via} <b>{props.location.carrier_name}</b></div>
			}
			{props.objExists(props.location, 'shipping_account_number') &&
			<div>{props.site.translation && props.site.translation.projects.labels.account_no} <b>{props.location.shipping_account_number}</b></div>
			}
			{props.objExists(props.location, 'shipping_tracking') &&
			<div>{props.site.translation && props.site.translation.projects.labels.tracking_no} <b>{props.location.shipping_tracking}</b></div>
			}
			{props.objExists(props.location, 'shipping_num_boxes') &&
			<div>{props.site.translation && props.site.translation.projects.labels.boxes} <b>{props.location.shipping_num_boxes}</b></div>
			}
			{props.objExists(props.location, 'shipping_cost') &&
			<div>{props.site.translation && props.site.translation.projects.labels.charge} <b>{props.priceDisplay(props.location.shipping_cost, 'en')}</b></div>
			}
			{props.objExists(props.location, 'shipping_started') &&
			<div>{props.site.translation && props.site.translation.projects.labels.shipping_date} <b>{props.dateDisplay(props.location.shipping_started)}</b></div>
			}
			{props.objExists(props.location, 'shipping_ended') &&
			<div>{props.site.translation && props.site.translation.projects.labels.delivery_date} <b>{props.dateDisplay(props.location.shipping_ended)}</b></div>
			}
		</div>
	)
}